// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2EQen","label":"Radio_label__3xRS4","checkMark":"Radio_checkMark__1ZOCv","disabled":"Radio_disabled__2t4Ck"};